import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const base_url = process.env.VUE_APP_API_BASE_URL;
let url = `${base_url}/elixio-pay`;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/nuvei-cards`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/nuvei-cards/${id}?include=customer`, options)
    .then((response) => {
      let customer = jsona.deserialize(response.data);
      delete customer.links;
      return customer;
    });
}

function add(nuveiCard) {
  const payload = jsona.serialize({
    stuff: nuveiCard,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/nuvei-cards?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function getNuveiSessionToken(organizationId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return axios
    .post(
      `${url}/nuvei-session-token`,
      { organization_id: organizationId },
      options
    )
    .then((response) => {
      return response.data;
    });
}

function initNuveiSession(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return axios
    .post(
      `${url}/init-nuvei-session-token`,
      {
        organization_id: params.organizationId,
        customer_id: params.customerId,
      },
      options
    )
    .then((response) => {
      return response.data;
    });
}

function update(nuveiCard) {
  const payload = jsona.serialize({
    stuff: nuveiCard,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/nuvei-cards/${nuveiCard.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/nuvei-cards/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  getNuveiSessionToken,
  initNuveiSession,
};
